import { render, staticRenderFns } from "./RestaurantForm.vue?vue&type=template&id=1280a497&"
import script from "./RestaurantForm.vue?vue&type=script&lang=ts&"
export * from "./RestaurantForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports